import {Injectable} from '@angular/core';

declare let toaster: any;
declare let $: any;

@Injectable()
export class CommonFunctions {
    constructor() {
    }

    public fmsBaseUrl() {
        return 'http://connexisfms.com/';
    }

    /**
     * Themes [primary,info,warning,danger,success]
     */
    public ShowToast(message, theme = 'success', title = '') {
        toaster(message, theme, title);
    }

    public setLoading(enable) {
        const loader = $('#loader_data');
        if (enable) {
            $(loader).removeClass('hide_elements');
        } else {
            $(loader).addClass('hide_elements');
        }
    }

    ShowMessage(Message, type) {
        $('#alert-message').html(this.MessageAlerts(Message, type));
    }

    public MessageAlerts(Message, type) {
        return '<div role="alert" class="m-alert m-alert--outline alert alert-' + type + ' alert-dismissible">\n' +
            ' <button aria-label="Close" class="close" data-dismiss="alert" type="button"></button>\n' +
            ' <span>' + Message + '</span>\n' +
            '</div>';
    }

    public OpenModel(id) {
        $('#' + id).modal('show');
    }

    public CloseModel(id) {
        $('#' + id).modal('hide');
    }


    public get_pagination(current_page, total_pages) {
        const links = [];
        if (total_pages >= 1 && current_page <= total_pages) {
            links.push(1);

            let i = Math.max(2, current_page - 5);
            if (i > 2) {
                links.push(' ... ');
            }

            for (; i < Math.min(current_page + 6, total_pages); i++) {
                links.push(i);
            }

            if (i != total_pages) {
                links.push(' ... ');
            }

            links.push(total_pages);

            return links;
        }
    }

    public jQFormSerializeArrToJson(formSerializeArr) {
        const formData = {};
        $.map(formSerializeArr, function (n, i) {
            formData[n.name] = n.value;
        });

        return formData;
    }

    public jQObjectToFormData(item) {
        const formData = new FormData();
        Object.keys(item).forEach(key => formData.append(key, item[key]));
        return formData;
    }
}
